import React from 'react'
import { motion } from 'framer-motion'


const WorkImages = ({filter,container,item}) => {
  return (
    <motion.div
    className="container"
    variants={container}
    initial="hidden"
    animate="visible"
  >
    <div className="flex flex-wrap -m-4 mt-6 justify-center">
    {filter.work.map((e)=>{
      return (

      <motion.div className="p-4 lg:w-1/3 sm:w-1/2 w-full" key={e.id} variants={item} >
      <div className="group h-full flex flex-col rounded-lg shadow-lg overflow-hidden bg-white text-left">
          <div className="h-48 overflow-hidden">
          {e.img?(
            <img src={e.img} alt={e.name} className="w-full h-full object-cover object-center group-hover:scale-110 transition ease-in duration-300" />
          ):(
            <div className="w-full h-full flex items-center justify-center p-6 bg-gradient-to-r from-yellow-300 to-[yellow]">
              <span className="text-2xl text-center font-bold tracking-wider text-gray-900">{e.name}</span>
            </div>
          )}
          </div>
          <div className="p-6 flex flex-col flex-grow">
            <span className="text-xs font-bold tracking-widest text-yellow-500">{e.category}</span>
            <h2 className="title-font text-xl font-bold text-gray-900 mt-1 mb-3">{e.name}</h2>
            <p className="leading-relaxed text-base mb-4">{e.description}</p>
            <div className="flex flex-wrap gap-2 mb-4">
              {e.tags.map((tag)=>(
              <span className="bg-gray-100 text-gray-700 text-sm rounded-full px-3 py-1" key={tag}>{tag}</span>
              ))}
            </div>
            {e.url&&(
            <a href={e.url} target="_blank" rel='noreferrer' className="mt-auto self-start text-md py-2 px-4 shadow-sm shadow-yellow-300 rounded-sm bg-[yellow] hover:bg-yellow-300 text-black font-bold">{e.linkLabel||"Visit Site"}</a>
            )}
          </div>
      </div>
      </motion.div>
      )
    })}
    </div>
    </motion.div>
  )
}

export default WorkImages
